export default __webpack_public_path__ + "static/media/logo.31c2048f.png";